export default import.meta.env.VITE_SW_ACTIVE;
